import { LifeCycleState } from '@carvana/merch-contracts';

export default function isTradeActive(
  lifeCycleState: LifeCycleState | undefined
): boolean {
  return (
    lifeCycleState === LifeCycleState.Active ||
    lifeCycleState === LifeCycleState.Scheduled ||
    lifeCycleState === LifeCycleState.AppliedToPurchase
  );
}
